import _ from 'lodash';
import axios from 'axios';

import {REHYDRATE} from 'redux-persist'
import {SET_PERSISTENT_VARIABLE, CLEAR_PERSISTENT_VARIABLES} from '../constants';

export default function persistent(state = {}, action) {
    switch (action.type) {
        case SET_PERSISTENT_VARIABLE:
            return {
                ...state,
                [action.payload.name]: action.payload.value,
            };
        case CLEAR_PERSISTENT_VARIABLES:
            return {};
        default:
            return state;
    }
}